import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setUser } from "./redux/userSlice";
import { setCompany } from "./redux/companySlice";
import AppRoutes from "./components/routes/AppRoutes";
import "../src/App.css";
import secureLocalStorage from "react-secure-storage";
import Swal from "sweetalert2";
import { getCurrencyIcon } from "./helper/appsession";
import { ClearSessionItems } from "./helper/appsession";
import { useNavigate } from "react-router-dom";
import { setFeatureMenu } from "./redux/featureMenuSlice";
import { setUserFeature } from "./redux/userFeatureSlice";
import { getStoredUser } from "./helper/sessionHelper";
import {
  getStoredUserFeatures,
  getStoredFeatureMenu,
  getStoredCompany,
} from "./helper/sessionHelper";
import { getUserDetailsByRefrestToken } from "./apis/apiServices/User";
import {
  GetUserWiseFeatureMenu,
  GetUserFeaturePermission,
  getApplicationModuleFeature,
  refreshAccessToken
} from "./apis/apiServices/User";
import { Loader, RedirectLoader } from "../src/components/Shared/PageLoader";
import { SystemCheckService } from './apis/apiServices/SystemCheck';

function App() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const user = useSelector((state) => state.user.data);
  const userCompany = useSelector((state) => state.company.data);
  const [systemCheck, setSystemCheck] = useState({
    isModalOpen: false,
  });

  // console.log("Login Page user: " + JSON.stringify(user));
  // console.log("Login Page userCompany: " + JSON.stringify(userCompany));

  const navigate = useNavigate();
  //console.log("REACT_APP_API_ASSETZ_BASE_URL: ", process.env.REACT_APP_API_ASSETZ_BASE_URL);

  const performLoginActions = async (action, params) => {
    // if (action === "draftAssetRequest") {
    //   let assetRequestId = params?.get("assetRequestId");
    //   let formId = params?.get("formId");
    //   let isDrafted = params?.get("isDrafted");

    //   navigate("/asset-preview", {
    //     state: {
    //       requestId: assetRequestId,
    //       formId: formId,
    //       action: action,
    //       isDrafted: isDrafted,
    //     },
    //   });
    // }
    if (action === "viewAssetRequest") {
      let assetRequestId = params?.get("iomId");
      let formId = params?.get("formId");
      let isApproved = params?.get("isApproved");
      let isReport = false;
      let currentStageId = params?.get("currentStageId");
      let departmentId = params?.get("departmentId");
      let requestNo = params?.get("requestNo");
      if (currentStageId === "1") {
        navigate("/AddAssetRequest", {
          state: {
            requestNo: requestNo,
            requestId: assetRequestId,
          },
        });
      } else {
        navigate("/asset-preview", {
          state: {
            requestId: assetRequestId,
            formId: formId,
            action: action,
            isApproved: isApproved,
            isReport: isReport,
          },
        });
      }
    }
    if (action === "viewActionOnRequest") {
      let assetRequestId = params?.get("iomId");
      let formId = params?.get("formId");
      let isApproved = params?.get("isApproved");
      let isReport = false;
      let currentStageId = params?.get("currentStageId");

      if (currentStageId === "1") {
        navigate("/UpdateActionOnRequest", {
          state: {
            requestId: assetRequestId,
            isReport: false,
            action: action,
          },
        });
      } else {
        navigate("/asset-action-preview", {
          state: {
            requestId: assetRequestId,
            formId: formId,
            action: action,
            isApproved: isApproved,
            isReport: isReport,
          },
        });
      }
    }
    if (action === "viewAssetMovement") {
      let assetMovementRequestId = params?.get("iomId");
      let isApproved = params?.get("isApproved");
      let formId = params?.get("formId");
      let isReport = false;
      let currentStageId = params?.get("currentStageId");
      let departmentId = params?.get("departmentId");
      let requestNo = params?.get("requestNo");

      if (currentStageId === "1") {
        navigate("/addAssetMovement", {
          state: {
            requestMovementId: assetMovementRequestId,
            movementIndentNo: requestNo,
            departmentId: departmentId,
            formId: formId,
            action: action,
          },
        });
      } else {
        navigate("/asset-movement-preview", {
          state: {
            requestMovementId: assetMovementRequestId,
            formId: formId,
            action: action,
            isApproved: isApproved,
            isReport: isReport,
          },
        });
      }
    }
    if (action === "viewAssetPurchase") {
      let assetQuotationRequestId = params?.get("iomId");
      let isApproved = params?.get("isApproved");
      let formId = params?.get("formId");
      let isReport = false;
      let currentStageId = params?.get("currentStageId");
      let departmentId = params?.get("departmentId");
      let requestNo = params?.get("requestNo");

      if (currentStageId === "1") {
        navigate("/addAssetQuotation", {
          state: {
            requestQuotationId: assetQuotationRequestId,
            quotationTypeId: 1,
            quotationIndentNo: requestNo,
            formId: formId,
            departmentId: departmentId,
            action: action,
          },
        });
      } else {
        navigate("/asset-purchase-preview", {
          state: {
            requestQuotationId: assetQuotationRequestId,
            formId: formId,
            action: action,
            isApproved: isApproved,
            isReport: isReport,
          },
        });
      }
    }
    if (action === "viewAssetHire") {
      let assetQuotationRequestId = params?.get("iomId");
      let isApproved = params?.get("isApproved");
      let formId = params?.get("formId");
      let isReport = false;
      let currentStageId = params?.get("currentStageId");
      let departmentId = params?.get("departmentId");
      let requestNo = params?.get("requestNo");

      if (currentStageId === "1") {
        navigate("/addAssetHire", {
          state: {
            requestQuotationId: assetQuotationRequestId,
            quotationTypeId: 2,
            quotationIndentNo: requestNo,
            formId: formId,
            departmentId: departmentId,
            action: action,
          },
        });
      } else {
        navigate("/asset-hire-preview", {
          state: {
            requestQuotationId: assetQuotationRequestId,
            formId: formId,
            action: action,
            isApproved: isApproved,
            isReport: isReport,
          },
        });
      }
    }
    if (action === "viewMovementRequest") {
      let movementRequestId = params?.get("iomId");
      let isApproved = params?.get("isApproved");
      let formId = params?.get("formId");
      let isReport = false;
      let currentStageId = params?.get("currentStageId");
      let departmentId = params?.get("departmentId");
      let requestNo = params?.get("requestNo");

      if (currentStageId === "1") {
        navigate("/SaveMaterialMovementRequest", {
          state: {
            materialMrId: movementRequestId,
            materialMovementNo: requestNo,
            formId: formId,
            action: action,
          },
        });
      } else {
        navigate("/ViewMaterialMovementRequest", {
          state: {
            materialMrId: movementRequestId,
            formId: formId,
            action: action,
            isApproved: isApproved,
            isReport: isReport,
          },
        });
      }
    }
    if (action === "viewMovementOrder") {
      let movementOrderRequestId = params?.get("iomId");
      let isApproved = params?.get("isApproved");
      let formId = params?.get("formId");
      let isReport = false;
      let currentStageId = params?.get("currentStageId");
      let departmentId = params?.get("departmentId");
      let requestNo = params?.get("requestNo");

      if (currentStageId === "1") {
        navigate("/UpdateMaterialMovementOrder", {
          state: {
            requestMovementId: movementOrderRequestId,
            materialMovementOrderIndentNo: requestNo,
            formId: formId,
            departmentId: departmentId,
            action: action,
          },
        });
      } else {
        navigate("/material-movement-order-preview", {
          state: {
            requestMovementId: movementOrderRequestId,
            formId: formId,
            action: action,
            isApproved: isApproved,
            isReport: isReport,
          },
        });
      }
    }
    if (action === "viewAssetScrap") {
      let assetScrapRequestId = params?.get("iomId");
      let isApproved = params?.get("isApproved");
      let formId = params?.get("formId");
      let isReport = false;

      navigate("/ViewAssetScrapRequest", {
        state: {
          requestId: assetScrapRequestId,
          action: action,
          isApproved: isApproved,
          isReport: isReport,
          formId: formId,
        },
      });
    }

    if (action === "approveAssetRequest") {
      let assetRequestId = params?.get("assetRequestId");
      let formId = params?.get("formId");
      let isApproved = params?.get("isApproved");

      navigate("/asset-preview", {
        state: {
          requestId: assetRequestId,
          formId: formId,
          action: action,
          isApproved: isApproved,
        },
      });
    }
    if (action === "approveActionOnRequest") {
      let actionOnRequestId = params?.get("actionOnRequestId");
      let formId = params?.get("formId");
      let isApproved = params?.get("isApproved");

      navigate("/asset-action-preview", {
        state: {
          requestId: actionOnRequestId,
          formId: formId,
          action: action,
          isApproved: isApproved,
        },
      });
    }
    // if (action === "btdAssetRequest") {
    //   let assetRequestId = params?.get("assetRequestId");
    //   let formId = params?.get("formId");
    //   navigate("/asset-preview", {
    //     state: {
    //       requestId: assetRequestId,
    //       formId: formId,
    //       action: action,
    //     },
    //   });
    // }
    if (action === "approveAssetMovementRequest") {
      let assetMovementRequestId = params?.get("assetMovementRequestId");
      let isApproved = params?.get("isApproved");
      let formId = params?.get("formId");

      navigate("/asset-movement-preview", {
        state: {
          requestMovementId: assetMovementRequestId,
          formId: formId,
          action: action,
          isApproved: isApproved,
        },
      });
    }
    if (action === "approveAssetQuotationRequest") {
      let assetQuotationRequestId = params?.get("assetQuotationRequestId");
      let isApproved = params?.get("isApproved");
      let formId = params?.get("formId");
      let quotationTypeId = params?.get("quotationTypeId");

      if (quotationTypeId === "1") {
        navigate("/asset-purchase-preview", {
          state: {
            requestQuotationId: assetQuotationRequestId,
            formId: formId,
            action: action,
            isApproved: isApproved,
          },
        });
      } else {
        navigate("/asset-hire-preview", {
          state: {
            requestQuotationId: assetQuotationRequestId,
            formId: formId,
            action: action,
            isApproved: isApproved,
          },
        });
      }
    }
    if (action === "approveMovementRequest") {
      let movementRequestId = params?.get("movementRequestId");
      let isApproved = params?.get("isApproved");
      let formId = params?.get("formId");

      navigate("/ViewMaterialMovementRequest", {
        state: {
          materialMrId: movementRequestId,
          formId: formId,
          action: action,
          isApproved: isApproved,
        },
      });
    }
    if (action === "approveMovementOrderRequest") {
      let movementOrderRequestId = params?.get("movementOrderRequestId");
      let isApproved = params?.get("isApproved");
      let formId = params?.get("formId");

      navigate("/material-movement-order-preview", {
        state: {
          requestMovementId: movementOrderRequestId,
          formId: formId,
          action: action,
          isApproved: isApproved,
        },
      });
    }
    if (action === "approveAssetScrapRequest") {
      let assetScrapRequestId = params?.get("assetScrapRequestId");
      let isApproved = params?.get("isApproved");

      navigate("/ViewAssetScrapRequest", {
        state: {
          requestId: assetScrapRequestId,
          action: action,
          isApproved: isApproved,
        },
      });
    }
    if (action === "btdAssetScrapRequest") {
      let assetScrapRequestId = params?.get("assetScrapRequestId");

      navigate("/ViewAssetScrapRequest", {
        state: {
          requestId: assetScrapRequestId,
          action: action,
        },
      });
    }
    // if (action === "recallIom") {
    //   let iomId = params?.get("iomId");
    //   navigate("/iom-preview", {
    //     state: { iomId: iomId, action: action, fromRecallRequestPage: true },
    //   });
    // }
  };

  const startSystemCheckInterval = (intervalMinutes = 1) => {
    const interval = setInterval(async () => {
      const body = {
        environmentId: process.env.REACT_APP_ENVIRONMENT,
        deviceTypeId: 3
      }
      const appVersion = process.env.REACT_APP_VERSION;
      const response = await SystemCheckService.systemCheck(body);
      if (systemCheck?.isModalOpen) return;

      if (response?.isSuccess) {
        if (response?.data?.assetZWebVersion !== undefined) {
          if (response?.data?.assetZWebVersion !== null) {
            if (response?.data?.assetZWebVersion !== String(appVersion)) {
              setSystemCheck(prevState => ({ ...prevState, isModalOpen: true, }))

              Swal.fire({
                title: 'Site Update',
                html: 'A new version has been released. Would you like to continue with the updated version? <div style="margin-top:20px;background-color: #fdf1e1; padding:10px; border:1px solid #ebc99c;text-align:left;color:#a57637; font-size:12px;"><strong>Update Now:</strong> <ul><li>Clears cache and browsing history</li><li>Reloads the site with the latest version</li></ul><strong>Skip & Continue:</strong> <ul style="margin-bottom:10px;"><li>Keeps your existing cache and browsing history</li><li>You’ll continue using the older version of the site</li></ul></div>',
                icon: 'warning',
                showCancelButton: true,
                cancelButtonText: 'Skip & Continue',
                confirmButtonText: 'Update Now',
              }).then((result) => {
                if (result.isConfirmed) {
                  window.location.reload(true);
                } else {
                  setSystemCheck(prevState => ({ ...prevState, isModalOpen: false, }))
                }
              });
            }
          }
        }
      }
    }, 300000); //intervalMinutes * 60 * 1000

    return interval;
  };

  const fetchUserDetailsByRefrestToken = async (
    refreshToken,
    action,
    params,
    companyId,
    isIframe
  ) => {
    const currencyIcon = getCurrencyIcon("inr");
    const jwtToken = await getRefreshAccessToken(refreshToken)
    let response = await getUserDetailsByRefrestToken({
      refreshToken,
      companyId,
    });
    if (response?.isSuccess) {
      //if (!isIframe) 
     
      {
        let userWiseFeatureMenuResponse = await fetchUserWiseFeatureMenu(
          response?.data?.userId,
          3,
          companyId
        );
        if (userWiseFeatureMenuResponse?.isSuccess) {
          secureLocalStorage.setItem(
            "featureMenu",
            userWiseFeatureMenuResponse?.data
          );
          dispatch(setFeatureMenu(userWiseFeatureMenuResponse?.data || {}));
        }

        let userFeaturePermission = await fetchUserFeaturePermission(
          response?.data?.userId,
          3,
          companyId
        );
        if (userFeaturePermission?.isSuccess) {
          secureLocalStorage.setItem("userFeatures", userFeaturePermission?.data);
          dispatch(setUserFeature(userFeaturePermission?.data || {}));
        }
      }

      console.log("response?.data", response);
      const userPayload = {
        authorized: true,
        currencyIcon,
        userId: response?.data?.userId,
        userName: response?.data?.username,
        firstName: response?.data?.firstName || "",
        lastName: response?.data?.lastName || "",
        userDepartmentId: response?.data?.userCompany?.userDepartmentId,
        // userDepartmentName: response?.data?.departmentName,
        userDepartmentName: response?.data?.userCompany?.userDepartmentName,
        userDesignationId: response?.data?.userCompany?.userDesignationId,
        userDesignationName: response?.data?.userCompany?.userDesignationName,
        companyId: response?.data?.userCompany?.companyId ?? 0,
        companyName: response?.data?.userCompany?.companyName ?? 0,
        companyCode: response?.data?.userCompany?.companyCode ?? 0,
        levelId: response?.data?.levelId,
        isIframe: isIframe,
        refreshToken: response?.data?.refreshToken,
        accessToken: jwtToken ||response?.data?.accessToken,
      };

      dispatch(setUser(userPayload));

      const companyPayload = {
        ...response?.data?.userCompany,
        isChangeCompanyModalOpen: false,
      };

      //console.log("companyPayload--", companyPayload);
      dispatch(setCompany(companyPayload));

      ClearSessionItems();
      //console.log("userPayload--", userPayload);
      secureLocalStorage.setItem("user", userPayload);
      secureLocalStorage.setItem("company", companyPayload);
      secureLocalStorage.setItem("authorized", true);
      secureLocalStorage.setItem("currencyicon", currencyIcon);

      if (action) {
        await performLoginActions(action, params);
      }
    } else {
      setLoading(false);
      await Swal.fire("Error", response?.data?.message, "error").then(() => {
        window.location.href = process.env.REACT_APP_VISHWAM_BASE_URL;
      });
      return;
    }

    const newUrl = window.location.origin + window.location.pathname;
    window.history.replaceState({}, document.title, newUrl);

    setLoading(false);
  };



  const getRefreshAccessToken = async (refreshToken) => {
    const request = {
      refreshToken: refreshToken || "",
      accessToken: localStorage.getItem("session_accesstoken") || "",

    };

    const res = await refreshAccessToken(request)
    console.log("refresh token response--", res);
    if (res?.isSuccess) {
      localStorage.setItem("session_accesstoken", res?.data);
      dispatch(setUser({ ...user, accessToken: res?.data }));
      return res?.data;
    }
  }

  // const fetchUserDetailsByRefrestToken = async (
  //   refreshToken,
  //   action,
  //   params
  // ) => {
  //   const currencyIcon = getCurrencyIcon("inr");
  //   let response = await getUserDetailsByRefrestToken({ refreshToken });
  //   if (response?.isSuccess) {
  //     let userWiseFeatureMenuResponse = await fetchUserWiseFeatureMenu(
  //       response?.data?.userId,
  //       3,
  //       response?.data?.userCompany?.companyId
  //     );
  //     if (userWiseFeatureMenuResponse?.isSuccess) {
  //       secureLocalStorage.setItem(
  //         "featureMenu",
  //         userWiseFeatureMenuResponse?.data
  //       );
  //       dispatch(setFeatureMenu(userWiseFeatureMenuResponse?.data || {}));
  //     }

  //     let userFeaturePermission = await fetchUserFeaturePermission(
  //       response?.data?.userId,
  //       3,
  //       response?.data?.userCompany?.companyId
  //     );
  //     if (userFeaturePermission?.isSuccess) {
  //       secureLocalStorage.setItem("userFeatures", userFeaturePermission?.data);
  //       dispatch(setUserFeature(userFeaturePermission?.data || {}));
  //     }

  //     const userPayload = {
  //       authorized: true,
  //       currencyIcon,
  //       userId: response?.data?.userId,
  //       userName: response?.data?.username,
  //       firstName: response?.data?.firstName || "",
  //       lastName: response?.data?.lastName || "",
  //       userDepartmentId: response?.userCompany?.departmentId,
  //       userDepartmentName: response?.userCompany?.departmentName,
  //       userDesignationId: response?.userCompany?.designationId,
  //       userDesignationName: response?.userCompany?.designationName,
  //       companyId: response?.data?.userCompany?.companyId ?? 0,
  //       companyName: response?.data?.userCompany?.companyName ?? 0,
  //       companyCode: response?.data?.userCompany?.companyCode ?? 0,
  //       levelId: response?.data?.levelId,
  //     };

  //     dispatch(setUser(userPayload));
  //     const companyPayload = {
  //       ...response?.data?.userCompany,
  //       isChangeCompanyModalOpen: false,
  //     };
  //     dispatch(setCompany(companyPayload));

  //     ClearSessionItems();
  //     secureLocalStorage.setItem("user", userPayload);
  //     secureLocalStorage.setItem("authorized", true);
  //     secureLocalStorage.setItem("currencyicon", currencyIcon);
  //     if (action) {
  //       await performLoginActions(action, params);
  //     }
  //   } else {
  //     setLoading(false);
  //     await Swal.fire("Error", response?.data?.message, "error").then(() => {
  //       window.location.href = process.env.REACT_APP_VISHWAM_BASE_URL;
  //     });
  //     return;
  //   }

  //   const newUrl = window.location.origin + window.location.pathname;
  //   window.history.replaceState({}, document.title, newUrl);

  //   setLoading(false);
  // };

  const validateUsersLoginDateTime = (timestampString) => {
    const timestamp = parseInt(timestampString, 10);
    const UrlUtcDate = new Date(timestamp).toISOString();

    if (Date.now() < timestamp) {
      // valid for 5 minutes
      return true;
    } else {
      Swal.fire("Warning", "Session Expired", "error").then(() => {
        window.location.href = process.env.REACT_APP_VISHWAM_BASE_URL;
      });
      return false;
    }
  };

  const fetchUserWiseFeatureMenu = async (userId, applicationId, companyId) => {
    try {
      let request = {};
      request.userId = userId;
      request.applicationId = applicationId;
      request.companyId = companyId;

      let response = await GetUserWiseFeatureMenu(request);

      return response;
    } catch (error) {
      return null;
    }
  };
  const fetchUserFeaturePermission = async (
    userId,
    applicationId,
    companyId
  ) => {
    try {
      let request = {};
      request.userId = userId;
      request.applicationId = applicationId;
      request.companyId = companyId;

      let response = await GetUserFeaturePermission(request);

      return response;
    } catch (error) {
      return null;
    }
  };

  useEffect(() => {
    const storedUser = getStoredUser();
    const storedCompany = getStoredCompany();
    if (storedUser) {
      dispatch(setUser(storedUser));
      dispatch(setCompany(storedCompany));
    }
  }, [dispatch]);
  useEffect(async () => {
    const params = new URLSearchParams(window.location.search);
    const userId = params?.get("userId");
    const refreshToken = params?.get("refreshToken");
    const validity = params?.get("validity");
    const action = params?.get("action");
    const companyId = params?.get("companyId");
    const isIframe = params?.get("isIframe") === "true" ? true : false;

    if (refreshToken) {
      // First-time login: fetch using token
      if (validity) {
        let isTokenDateValid = validateUsersLoginDateTime(validity);
        if (!isTokenDateValid) {
          setLoading(false);
          return;
        }
      }
      fetchUserDetailsByRefrestToken(
        refreshToken,
        action,
        params,
        parseInt(companyId),
        isIframe
      );
    } else if (user && user?.authorized) {
      if (userId && action && Number(userId) === user?.userId) {
        await performLoginActions(action, params);
      } else if (userId && action && Number(userId) !== user?.userId) {
        Swal.fire(
          "",
          "You are not intented user to access this page.",
          "warning"
        );
      }

      setLoading(false);
    } else {
      const storedUser = getStoredUser();
      var storedUserFeatures = getStoredUserFeatures();
      var featureMenu = getStoredFeatureMenu();

      if (storedUser?.authorized) {
        // Restore user from local/session storage if Redux is empty
        if (userId && action && Number(userId) === storedUser?.userId) {
          await performLoginActions(action, params);
        } else if (userId && action && Number(userId) !== storedUser?.userId) {
          Swal.fire(
            "",
            "You are not intented user to access this page.",
            "warning"
          );
        }
        dispatch(setUser(storedUser));

        let featureMenuResponse = await fetchUserWiseFeatureMenu(
          storedUser?.userId,
          3,
          storedUser?.companyId
        );
        if (featureMenuResponse?.isSuccess) {
          featureMenu = featureMenuResponse?.data;
        }

        let userFeaturesResponse = await fetchUserFeaturePermission(
          storedUser?.userId,
          3,
          storedUser?.companyId
        );
        if (userFeaturesResponse?.isSuccess) {
          storedUserFeatures = userFeaturesResponse?.data;
        }

        if (storedUserFeatures) {
          dispatch(setUserFeature(storedUserFeatures));
        }
        if (featureMenu) {
          dispatch(setFeatureMenu(featureMenu));
        }

        setLoading(false);
      } else {
        // No token, no session, redirect to login/base site
        window.location.href = process.env.REACT_APP_VISHWAM_BASE_URL;
      }
    }
  }, []);

  useEffect(() => {
    debugger;
    if (!user) return;
    const systemCheckInterval = startSystemCheckInterval(3)
    return () => {
      clearInterval(systemCheckInterval);
    };
  }, [user]);

  return (
    // <Fragment>
    //  <WithAuto>
    //   <AppRoutes />
    //   </WithAuto>
    // </Fragment>
    <Fragment>
      {/* {loading && !user?.isIframe && <RedirectLoader />} */}
      {loading && <Loader />}
      <AppRoutes />
    </Fragment>
  );
}

export default App;
